import React, { useMemo } from "react";
import { Select } from "antd";
import { IAppStore } from "../../stores/Interfaces";
import { Option, SelectOption } from "../common/forms/Interfaces";

interface Props {
  store?: IAppStore;
  placeholder?: string;
  onChange: (value: string) => void;
  onSearch: (value: string) => void;
}

const SelectClient: React.FC<Props> = ({
    store,
    placeholder,
    onChange,
    onSearch
    }) => {
  const settingsStore = store?.settingsStore;
  const clients = useMemo(
    (): SelectOption[] =>
      settingsStore?.clientsWithRates.map(
        (client: Option): SelectOption => ({
          value: client.value,
          label: client.title,
        })
      ) || [],
    [settingsStore]
  );

    return (
        <Select
            options={clients}
            placeholder={placeholder}
            onChange={onChange}
            onSearch={onSearch}
            showSearch
            optionFilterProp="label"
            filterOption={(inputValue, option) => {
                if (!option) {
                    return false;
                }
                return (
                    (option.label as string)
                        .toLowerCase()
                        .indexOf((inputValue || "").toLowerCase()) === 0
                );
            }}
        />
    );
};

export default SelectClient;
